var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      (typeof _vm.ownerInsuranceID === 'string' || typeof _vm.ownerInsuranceID === 'number') &&
        _vm.documentID > 0
    )?_c('span',{staticStyle:{"margin-left":"-20px"}},[_c('button',{staticClass:"button is-info is-light is-small is-outline is-rounded",on:{"click":function($event){$event.preventDefault();return _vm.downloadPdf(_vm.ownerInsuranceID)}}},[_vm._v(" Pdf ")])]):_c('span',[_vm._v("   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }